import { ChapterType } from "../../../../types/chapter";
import { Style } from "@surge-global-engineering/rpdf-types";

export const ChapterTypeExtraStyleConfig = (chapterType: ChapterType, contentHeight: number): {
    container?: Style,
    chapterSubTitle?: Style,
    chapterNumber?: Style,
    titleImageContainer?: Style,
    marginImageContainer?: Style,
} => {
    switch (chapterType) {
        case "toc":
            return {};
        case "title":
            return {};
        case "blurbs":
            return {};
        case "dedication":
            return {};
        case "epigraph":
            return {};
        case "foreword":
            return {};
        case "introduction":
            return {};
        case "preface":
            return {};
        case "prologue":
            return {};
        case "epilogue":
            return {};
        case "afterword":
            return {};
        case "acknowledgments":
            return {};
        case "about-author":
            return {};
        case "also-by":
            return { container: { paddingTop: Math.round(contentHeight / 8) }, };
        case "custom":
            return {};
        case "image":
            return {};
        case "chapter":
            return {};
        case "copyrights":
            return {};
        default:
            return {};
    }
};